import React from "react";
import styles from "./energy-requirements.module.scss";
import { SelectedApplianceConfig } from "./energy-requirements.types";
import { PlusOnlyIcon } from "../../../../../assets/icons";
import { Button } from "../../../components";

interface ApplianceSummaryProps {
	selectedAppliances: SelectedApplianceConfig[];
	onAddAnother: () => void;
	onCancel: () => void;
	onSave: () => void;
}

export const ApplianceSummary: React.FC<ApplianceSummaryProps> = ({ selectedAppliances, onAddAnother, onCancel, onSave }) => {
	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div className={styles.header}>
					<div className={styles.iconWrapper}>
						<span className={styles.questionMark}>&#10067;</span>
					</div>
					<div className={styles.titleSection}>
						<h2 className={styles.title}>Appliances</h2>
						<p className={styles.subtitle}>Add home appliances to calculate your energy usage</p>
					</div>
				</div>

				<div className={styles.summaryList}>
					{selectedAppliances.map((config, index) => (
						<div key={`${config.applianceId}-${index}`} className={styles.summaryCard}>
							<div className={styles.summaryCardHeader}>
								<div className={styles.applianceChip}>
									{config.applianceIconUrl && <img src={config.applianceIconUrl} alt={config.applianceName} className={styles.applianceChipIcon} />}
									<span className={styles.applianceChipName}>{config.applianceName}</span>
								</div>
							</div>
							<div className={styles.summaryCardBody}>
								<span className={styles.summaryDetail}>
									Quantity: {config.quantity}&nbsp;&nbsp;Daily Usage: {config.dailyUsage} hrs
								</span>
							</div>
							<div className={styles.summaryCardFooter}>
								<span className={styles.savedBadge}>Saved</span>
							</div>
						</div>
					))}
				</div>

				<button className={styles.addApplianceButton} onClick={onAddAnother}>
					<span className={styles.addApplianceIcon}>
						<PlusOnlyIcon />
					</span>
					Add Another
				</button>

				<div className={styles.landingFooter}>
					<div className={styles.landingFooterInner}>
						<Button variant="secondary" onClick={onCancel}>
							Cancel
						</Button>
						<Button variant="primary" onClick={onSave}>
							Save
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
